var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "qb-result-wrapper" },
    [
      _vm.shortVideo.length
        ? _c("QBVideoList", {
            ref: "qbVideoListRef",
            attrs: {
              "get-doc-info": _vm.getDocInfo,
              "get-short-video-play-info": _vm.getShortVideoPlayInfo,
            },
          })
        : _c("NoResult"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }